import { render } from "./portfolioPage.vue?vue&type=template&id=206ea97a&scoped=true"
import script from "./portfolioPage.vue?vue&type=script&lang=js"
export * from "./portfolioPage.vue?vue&type=script&lang=js"

import "./portfolioPage.vue?vue&type=style&index=0&id=206ea97a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-206ea97a"]])

export default __exports__